// src/lib/session-role.js — résolution SÉCURISÉE du rôle + logIds depuis la session.
//
// SÉCURITÉ : l'autorisation côté front ne se fie QU'À app_metadata, signé par
// Supabase Auth et IMMUABLE côté client. user_metadata est MUTABLE par le client
// (supabase.auth.updateUser) → s'y fier permettrait à un utilisateur de forger
// role='admin' / logIds et de faire apparaître le shell admin. On l'ignore donc
// totalement pour role/logIds. Défaut 'menage' = moindre privilège ; le backend
// bloque de toute façon un rôle absent (current_role_safe() lit app_metadata).

export function resolveUserFromSession(session) {
  if (!session?.user) return null
  const appMeta = session.user.app_metadata || {}
  // user_metadata = AFFICHAGE PUR (prénom/nom). MUTABLE côté client → JAMAIS lu
  // pour l'autorisation (role/logIds/managed_agents restent dérivés d'app_metadata
  // signé ci-dessus). Ces noms n'alimentent que l'accueil « Bonjour [Prénom] » et
  // les avatars à initiale.
  const userMeta = session.user.user_metadata || {}
  return {
    id: session.user.id,
    email: session.user.email,
    role: appMeta.role || 'menage',
    logIds: Array.isArray(appMeta.logIds) ? appMeta.logIds : [],
    first_name: typeof userMeta.first_name === 'string' ? userMeta.first_name : '',
    last_name: typeof userMeta.last_name === 'string' ? userMeta.last_name : '',
    // Permissions 42 Phase 3 Lot 1 (amendement C) — pool d'agents managés par
    // l'orchestrateur (lecture-affichage des runs du pool). GARDÉ PAR LE RÔLE
    // (défense en profondeur) : un claim managed_agents orphelin sur un compte
    // NON-orchestrateur (ex. ménage) est IGNORÉ → jamais de claim lu hors rôle.
    // Le cloisonnement réel reste la RLS (orchestrateur_manages_agent) ; ce
    // champ ne sert qu'à l'affichage côté UI (jamais à autoriser).
    managed_agents:
      appMeta.role === 'orchestrateur' && Array.isArray(appMeta.managed_agents)
        ? appMeta.managed_agents
        : [],
  }
}
